module.exports = __webpack_public_path__ + "img/132.97b4c371.jpg";